import { useState } from 'react'
import Image from 'next/legacy/image'
import PropTypes from 'prop-types'

import FlatButton from '../FlatButton'
import Text from '../Text'

import styles from './style.module.css'

import { useDidMount,useIsWidthLarger } from '@utils/hooks'

function PageSelector({ page, pageTotal, shallow }) {
  const [mounted, setMounted] = useState(false)

  useDidMount(() => {
    setMounted(true)

    return () => {
      setMounted(false)
    }
  })

  const isMedium = useIsWidthLarger(768)

  if (!mounted) return null

  const prevParam = new URLSearchParams(window.location.search)
  prevParam.set('page', page - 1)

  const nextParam = new URLSearchParams(window.location.search)
  nextParam.set('page', page + 1)

  const isPageTotalMoreThan5 = pageTotal > 5
  const isCurrentPageLessThanTotal = page + 2 < pageTotal
  
  const pageNumbers =
    page < 5
      ? [
        ...Array.from(
          { length: isPageTotalMoreThan5 ? 5 : pageTotal },
          (_, k) => k + 1
        ),
        ...(isPageTotalMoreThan5 ? ['...', pageTotal] : []),
      ]
      : [
        ...[-2, -1, 0, 1, 2].map(v => page + v).filter(v => v <= pageTotal),
        ...(isCurrentPageLessThanTotal ? ['...', pageTotal] : []),
      ]
  const pageNumbersMobile =
    page < 3
      ? [
        ...Array.from(
          { length: isPageTotalMoreThan5 ? 2 : pageTotal },
          (_, k) => k + 1
        ),
        ...(isPageTotalMoreThan5 ? ['...', pageTotal] : []),
      ]
      : [
        ...[-1, 0].map(v => page + v).filter(v => v <= pageTotal),
        ...(page < pageTotal ? ['...', pageTotal] : []),
      ]
  
  return (
    <div className={styles.container}>
      <Text variant="lightTitle">
        <FlatButton
          link={`${window.location.pathname}?${prevParam.toString()}`}
          disabled={page - 1 < 1}
          shallow={shallow}
        >
          <Image
            alt="previous page"
            src="https://static.base.co.id/scroll-right-black.svg"
            height={23}
            width={45}
            className={styles.prevArrow}
          />
          &nbsp; Prev
        </FlatButton>
      </Text>

      {(isMedium ? pageNumbers : pageNumbersMobile).map((value, index) => {
        const pageNumberParam = new URLSearchParams(window.location.search)
        pageNumberParam.set('page', value)

        return (
          <Text
            key={`page-${index}`}
            variant="lightTitle"
            className={page === value ? styles.bold : ''}
          >
            <FlatButton
              link={
                typeof value !== 'string'
                  ? `${window.location.pathname}?${pageNumberParam.toString()}`
                  : undefined
              }
              shallow={shallow}
            >
              {value}
            </FlatButton>
          </Text>
        )
      })}

      <Text variant="lightTitle">
        <FlatButton
          link={`${window.location.pathname}?${nextParam.toString()}`}
          disabled={page + 1 > pageTotal}
          shallow={shallow}
        >
          Next &nbsp;
          <Image
            alt="next page"
            src="https://static.base.co.id/scroll-right-black.svg"
            height={23}
            width={45}
          />
        </FlatButton>
      </Text>
    </div>
  )
}

PageSelector.propTypes = {
  page: PropTypes.number,
  pageTotal: PropTypes.number,
  shallow: PropTypes.bool,
}

export default PageSelector
